import StepperComponent from "components/blocks/stepper/Stepper";
import ChannelsStep from "./channels/ChannelsStep";
import CloudStorageStep from "./cloudStorage/CloudStorageStep";
import ReviewPurchaseStep from "./reviewPurchase/ReviewPurchaseStep";
import * as s from "./UsageSignupStyled";
import { UsageSignupFlow } from "./useUsageSignupFlow";

interface Props {
  title?: string;
  showTitle?: boolean;
  flow: UsageSignupFlow;
  onAddPayment: () => void;
}

export default function UsageSignupContent({
  title = "myDW Subscription Sign Up",
  showTitle = true,
  ...props
}: Props): JSX.Element {
  return (
    <>
      {showTitle && <s.Title>{title}</s.Title>}
      <StepperComponent
        activeStep={props.flow.state.currentStep}
        steps={props.flow.state.steps}
        onClick={
          props.flow.state.noPermission
            ? undefined
            : props.flow.actions.onChangePage
        }
      />
      <div className="inner-content">
        {props.flow.state.currentStepKey === "channels" && (
          <ChannelsStep flow={props.flow} />
        )}
        {props.flow.state.currentStepKey === "cloudStorage" && (
          <CloudStorageStep flow={props.flow} />
        )}
        {props.flow.state.currentStepKey === "reviewPurchase" && (
          <ReviewPurchaseStep
            flow={props.flow}
            onAddPayment={props.onAddPayment}
          />
        )}
      </div>
    </>
  );
}
